const config = {
  silent: false,
  logLevel: "warn"
};

function isPlainObject(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

const typeDefaults = () => ({
  func: () => void 0,
  bool: true,
  string: "",
  number: 0,
  array: () => [],
  object: () => ({}),
  integer: 0
});

export { config as c, isPlainObject as i, typeDefaults as t };
//# sourceMappingURL=vue-types.8139b772.mjs.map
